export default __webpack_public_path__ + "static/media/card-selector.3544b057.svg";